// Core
// 
import { Controller } from 'stimulus';

// Helpers
// 
import { addClass, removeClass, hasClass } from '../../../dom-helper';

// Plugins
// 
import TingleModal from 'tingle.js';
import axios, { AxiosResponse } from 'axios';

export default class extends Controller {
  static targets = [
    'form', 'response', 'counter', 'actions',
    'floorplanOverviewAction', 'bulkEditAction',
    'attributesContainer', 'reportsContainer', 'reportTemplatesContainer', 'prettyProjectTemplatesContainer', 'itemsContainer'
  ];


  // ['form', 'counter', 'actions']
  // ['task', 'overview', 'report', 'edit']

  formTarget: any;
  responseTarget: any;
  counterTarget: any;
  actionsTarget: any;

  // floorplanOverviewActionTarget: any;
  bulkEditActionTarget: any;

  attributesContainerTarget: any;
  reportsContainerTarget: any;
  reportTemplatesContainerTarget: any;
  prettyProjectTemplatesContainerTarget: any;
  itemsContainerTarget: any;

  refresh(event) {
    
    // Dont submit the form if the target is a datepicker range because
    // 
    if (!hasClass(event.target, 'datepicker-range')) {
      this.formTarget.submit()
    }
  }

  // overviewAssets() {
  //   if (hasClass(this.itemsContainerTarget, '-state-invisible')) {
  //     removeClass(this.itemsContainerTarget, '-state-invisible')
  //   } else {
  //     addClass(this.itemsContainerTarget, '-state-invisible')
  //   }
  // }

  overviewAssets(event) {
    event.preventDefault();
  
    const container = document.querySelector('[data-target="items--filters.itemsContainer"]');
    container.classList.toggle('-state-invisible');
  
    const checkbox = event.currentTarget.querySelector('input[type=checkbox]');
    const iconElement = event.currentTarget.querySelector('.catalogue-action-btn__icon span');
    const textElement = event.currentTarget.querySelector('.action-btn-text');
  
    const itemsAreHidden = container.classList.contains('-state-invisible');
  
    if (itemsAreHidden) {
      iconElement.textContent = 'visibility_off';
      textElement.textContent = 'View EFFC&M™';
      checkbox.checked = false;
    } else {
      iconElement.textContent = 'visibility';
      textElement.textContent = 'Hide EFFC&M™';
      checkbox.checked = true;
    }
  }

  showAdditionalFilters() {
    event.preventDefault();

    const modal = new TingleModal.modal({
      footer: true,
      stickyFooter: false,
      onOpen: () => { },
      beforeClose: () => {
        return true
      },
      
      onClose: () => { 
        modal.destroy()
      }
    });

    modal.setContent(this.attributesContainerTarget.innerHTML);
    modal.open();
  }

  showReportingOptions(event: any) {
    event.preventDefault();

    const modal = new TingleModal.modal({
      onOpen: () => { },
      beforeClose: () => {
        return true
      },
      
      onClose: () => { 
        modal.destroy()
      }
    });

    modal.setContent(this.reportsContainerTarget.innerHTML);
    modal.open();
    // const container = this.reportsContainerTarget;
    // if (!container) return;

    // // Toggle visibility of the inline report panel just below the button
    // if (hasClass(container, '-state-invisible')) {
    //   removeClass(container, '-state-invisible');
    // } else {
    //   addClass(container, '-state-invisible');
    // }
  }

  showReportTemplates(event: any) {
    event.preventDefault();
    let reportType = event.currentTarget.dataset.reportType; // Use data attribute!
    console.log('[showReportTemplates] Button clicked:', reportType);

    // Only use dynamic loading for Pretty Project Reports
    if (reportType === 'Pretty_Project_Report') {
      this.showPrettyProjectTemplates(event, reportType);
    } else {
      // Use existing functionality for all other report types
      this.showExistingTemplates(event, reportType);
    }
  }

  showPrettyProjectTemplates(event: any, reportType: string) {
    const modal = new TingleModal.modal({
      onOpen: () => {
        // No need for dynamic loading - templates are already loaded
      },
      beforeClose: () => true,
      onClose: () => { 
        console.log('[showPrettyProjectTemplates] Modal closed.');
        modal.destroy(); 
      }
    });

    // Use the Pretty Project Report templates container
    modal.setContent(this.prettyProjectTemplatesContainerTarget.innerHTML);
    modal.open();
    console.log('[showPrettyProjectTemplates] Modal opened with Pretty Project templates.');
  }

  showExistingTemplates(event: any, reportType: string) {
    const modal = new TingleModal.modal({
      onOpen: () => {
        const field = document.getElementById('report_type_field') as HTMLInputElement;
        console.log('[showReportTemplates] Modal opened. Field found:', !!field);
        if (field) {
          field.value = reportType;
          console.log('[showReportTemplates] Field value set:', field.value);
        }
      },
      beforeClose: () => true,
      onClose: () => { 
        console.log('[showReportTemplates] Modal closed.');
        modal.destroy(); 
      }
    });

    modal.setContent(this.reportTemplatesContainerTarget.innerHTML);
    modal.open();
    console.log('[showReportTemplates] Modal opened with content.');

    // Find all report_type fields in the modal and set their value
    const modalContent = document.querySelector('.tingle-modal-box');
    if (modalContent) {
      const fields = modalContent.querySelectorAll('[id^="report_type_field_"]');
      fields.forEach((field: HTMLInputElement) => {
        field.value = reportType;
      });
    }
  }

  bulkEdit() { }

  submitReportRequest() {

  }

  toggleFilterPanel(event: any) {
    const filterName = event.currentTarget.dataset.filterName;
    const panels = document.querySelectorAll('.catalogue-filter-panel');

    panels.forEach((panel: HTMLElement) => {
      if (panel.id !== `filter-panel-${filterName}`) {
        panel.style.display = 'none';
      }
    });

    const targetPanel = document.getElementById(`filter-panel-${filterName}`);
    if (targetPanel) {
      targetPanel.style.display = targetPanel.style.display === 'none' ? 'block' : 'none';
    }

    // Toggle open state on chips
    const chips = document.querySelectorAll('.filter-chip');
    chips.forEach((chip: HTMLElement) => {
      if (chip.dataset.filterName === filterName) {
        chip.classList.toggle('filter-chip--open');
      } else {
        chip.classList.remove('filter-chip--open');
      }
    });
  }

  toggleFiltersPanel() {
    const container = document.querySelector('.catalogue-extra-filters') as HTMLElement;
    if (container) {
      container.style.display = container.style.display === 'none' ? 'block' : 'none';
    }
  }

  toggleBulkActionsDropdown(event: any) {
    event.preventDefault();
    event.stopPropagation();
    
    const dropdown = event.currentTarget.closest('.dropdown');
    if (!dropdown) return;
    
    const menu = dropdown.querySelector('.dropdown-content') as HTMLElement;
    if (!menu) return;
    
    const isVisible = menu.style.display === 'block';
    
    // Close all other dropdowns
    document.querySelectorAll('.catalogue-action-dropdown .dropdown-content').forEach((m: HTMLElement) => {
      m.style.display = 'none';
    });
    
    // Toggle current dropdown
    menu.style.display = isVisible ? 'none' : 'block';
    
    // Add click-outside handler if opening
    if (!isVisible) {
      const closeHandler = (e: MouseEvent) => {
        const target = e.target as HTMLElement;
        if (!dropdown.contains(target)) {
          menu.style.display = 'none';
          document.removeEventListener('click', closeHandler);
        }
      };
      // Use setTimeout to avoid immediate closure
      setTimeout(() => {
        document.addEventListener('click', closeHandler);
      }, 0);
    }
  }

  submitCatalogueForm(event: any) {
    event.preventDefault();
    const select = event.target as HTMLSelectElement;

    // Sync to hidden field first
    this.syncCatalogueId(event);

    // Only include view_assets and catalogue_id (and optionally utf8/button to match legacy URLs)
    const params = new URLSearchParams();
    params.append('utf8', '✓');
    params.append('view_assets', 'on');
    const catalogueId = select.value;
    if (catalogueId) {
      params.append('catalogue_id', catalogueId as string);
    }
    params.append('button', '');
    
    // Navigate to the clean URL
    const url = `${window.location.origin}${select.dataset.itemsUrl || '/items'}?${params.toString()}`;
    window.location.href = url;
  }

  syncCatalogueId(event: any) {
    // Sync the catalogue dropdown value to the hidden field in the main form
    const select = event.target as HTMLSelectElement;
    const hiddenField = document.getElementById('form_catalogue_id') as HTMLInputElement;
    if (hiddenField) {
      hiddenField.value = select.value || '';
    }
  }

  syncCatalogueIdBeforeSubmit(event: any) {
    // Sync catalogue_id from dropdown to hidden field before form submission
    const select = document.getElementById('catalogue_dropdown_select') as HTMLSelectElement;
    const hiddenField = document.getElementById('form_catalogue_id') as HTMLInputElement;
    if (select && hiddenField) {
      hiddenField.value = select.value || '';
    }
  }

  initialize() {
    // addClass(this.floorplanOverviewActionTarget, 'disabled');
    // addClass(this.bulkEditActionTarget, 'disabled');
  }

  connect() { 
    console.log('connected?')
  }

  disconnect() { }
}